import { isServer } from 'solid-js/web';
import { z } from 'zod';
/**
 * Important: use a globalThis symbol to avoid any sort of clash. This creates a unique reference.
 */
const serverSym = Symbol.for('__SERVER_CONFIG__');

const schema = z.object({
	API_BASE: z.string().default('/'),
	CF_TURNSTILE_SITE_KEY: z.string(),
	POSTHOG_PROJECT_API_KEY: z.string(),
	POSTHOG_API_HOST: z.string(),
	ENVIRONMENT: z.enum(['development', 'staging', 'production']).default('development'),
});

export type Config = z.infer<typeof schema>;

declare global {
	interface Window {
		__WEB_CONFIG__: Config;
	}
}

export function getConfigValue<K extends keyof Config, T = Config[K]>(key: K, fallback?: T): T {
	return !isServer && window.__WEB_CONFIG__
		? (window.__WEB_CONFIG__[key] as T)
		: // @ts-expect-error TS still doesn't let you declare a symbol as an index
			globalThis[serverSym]
			? // @ts-expect-error TS still doesn't let you declare a symbol as an index
				globalThis[serverSym][key]
			: (fallback as T);
}
